import { FlexBox } from '@fable/components'
import { css } from '@fable/theme'
import { MomStreaks } from '../charts'
import { StreakMap } from '../charts/advanced_charts'
import { useStatsTheme } from '../../theme/ctx'

export const StatsProfileStreaks = () => {
  const theme = useStatsTheme((s) => s.theme)
  const isDarkTheme = theme.id.includes('dark')

  return (
    <FlexBox
      className={css`
        padding-bottom: ${isDarkTheme ? 12 : 50}px;
        width: 100%;
        gap: 20px;
      `}
      flexDirection="column"
    >
      <MomStreaks />
      <StreakMap />
    </FlexBox>
  )
}
